import { useCallback, useState } from "react";
import {
  AndamentoAssinatura,
  buscarAndamentosAssinaturaService,
} from "../../../services/buscarAndamentosAssinaturaService";

export const useBuscarAndamentosAssinatura = () => {
  const [andamentos, setAndamentos] = useState<AndamentoAssinatura[]>([]);
  const [loading, setLoading] = useState(false);

  const buscar = useCallback(async (assinaturaId: number) => {
    if (!assinaturaId) return;

    setLoading(true);
    try {
      const dados = await buscarAndamentosAssinaturaService(assinaturaId);
      setAndamentos(dados);
    } catch (error) {
      console.error("Erro ao buscar andamentos da assinatura:", error);
      setAndamentos([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    andamentos,
    loading,
    buscar,
  };
};
